var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-wrapper", class: _vm.classObj },
    [
      _vm.device === "mobile" && _vm.sidebar.opened && !_vm.hideLayout
        ? _c("div", {
            staticClass: "drawer-bg",
            on: { click: _vm.handleClickOutside },
          })
        : _vm._e(),
      !_vm.hideLayout
        ? _c("sidebar", { staticClass: "sidebar-container" })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "main-container",
          class: {
            hasTagsView: !_vm.hideLayout,
            "full-screen": _vm.hideLayout,
          },
        },
        [
          !_vm.hideLayout
            ? _c(
                "div",
                { class: { "fixed-header": false } },
                [_c("navbar"), _c("tags-view")],
                1
              )
            : _vm._e(),
          _c("app-main"),
        ],
        1
      ),
      _c("IncomingCall", { ref: "incomingCall" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }